import Handlebars from 'handlebars';
import $ from 'jquery';

function render(parameters){
  $('#view .view__hbs').empty();
  if(parameters.lunchsortby=='menu'){
    $('#view .view__hbs').append(Handlebars.templates.LunchMenuTemplate(parameters));
  } else {
    $('#view .view__hbs').append(Handlebars.templates.LunchRestaurantsTemplate(parameters));
  }
}
export default {
  render
};
